import Global from '../global';
import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';

const { eEventLogType, eSources } = enums;
import { Level } from '@unified-client/event-formatter';
import ClickstreamFacade from '../facades/clickstream-facade';

function logEventToClickstream(event, logData) {
  event.tryNo = logData.tryNo;
  // eslint-disable-next-line
  console.log(
    `${event.tryNo ? '[logging] ' + event.type + ' tryNo:' + event.tryNo : ''}`
  );

  if (!process.env.BROWSER) {
    event.source = eSources.server;
    ClickstreamFacade.sendEventToClickstream(event, Level.debug, logData);
  }
}

function getResponseDetails(response, requestData) {
  const status = response && response.status ? response.status : undefined;
  const durationInMS =
    response && response.config && response.config.metadata
      ? Number(Date.now() - response.config.metadata.startTime)
      : undefined;

  return { ...requestData, status, durationInMS };
}

export function logRequestToClickstream(requestData, logData) {
  let event = { ...requestData, type: eEventLogType.Request };
  logEventToClickstream(event, logData);
}

export function responseSuccessCb(
  response,
  requestData,
  logData,
  logToClickstream = false
) {
  if (logToClickstream) {
    const responseDetails = getResponseDetails(response, requestData);
    const event = {
      ...responseDetails,
      errorMessage: 'N/A',
      source: eSources.server,
      type: eEventLogType.ResponseSuccess
    };
    logEventToClickstream(event, logData);
  }
}

export function responseErrorCb(
  error,
  requestData,
  logData,
  logToClickstream = false
) {
  const responseDetails = getResponseDetails(error.response, requestData);
  let errorMessage = error && error.message ? error.message : 'N/A';
  if (error && error.response && error.response.data) {
    errorMessage += `. Response data: ${JSON.stringify(error.response.data)}`;
  }
  const resource = getPathName(responseDetails.url);
  Global.logger.error(
    `[RES ${resource}] ${errorMessage}. Response Details: ${JSON.stringify(
      responseDetails
    )}`
  );

  if (logToClickstream) {
    const event = {
      ...responseDetails,
      errorMessage,
      source: eSources.server,
      type: eEventLogType.ResponseError
    };
    logEventToClickstream(event, logData);
  }
  let err = new Error(error);
  err.code = error.code;
  throw err;
}

export function getPathName(url) {
  if (process.env.BROWSER) {
    var parser = document.createElement('a');
    parser.href = url;

    return parser.pathname;
  } else {
    var { URL } = require('url');
    return new URL(url).pathname;
  }
}

export function sendRequestSuccess(res, data) {
  res.status(200).send(data);
}

export function sendRequestError(res, status, message, ex) {
  res
    .status(status)
    .send({ message, internalError: ex ? ex.toString() : undefined });
}

/**
 * Gets the sc_logger_uid from window if defined
 */
export function getSCLoggerUID() {
  return typeof window !== 'undefined' ? window.sc_logger_uid : null;
}

export class LogTimer {
  constructor(logger, label) {
    //this.startTime = new Date();
    this.logger = logger;
    this.label = label;
    this.startTime = new Date();
  }

  start() {
    this.startTime = new Date(); // set a new time if i want to start later
  }

  stop() {
    this.stopTime = new Date();
    if (this.logger) {
      this.logger.info(
        `exec_time[${this.label}] [${this.stopTime - this.startTime} ms]`
      );
    }
  }
}
